






































import { ref, createComponent } from '@vue/composition-api'
import permissionCheckbox from './permissionCheckbox.vue'
import { grantPower } from '@/service/public'
import { Message } from '@heytap/cook-ui'
import { FilePower } from '@/constant'
import { isEmpty } from 'lodash'
export default createComponent({
    name: 'permissionGrant',
    props: {
        grantPermission: {
            type: Boolean,
            default: false,
            require: true,
        },
    },
    components: { permissionCheckbox },
    setup(props, { root }) {
        const outVisible = props.grantPermission
        const checkList = ref<number[]>([])
        const users = ref<string>()
        const dirId = root.$store.state.publicStore.tableRowData.id

        const closeOut = () => {
            root.$store.commit('publicStore/SET_IS_GRANT_PERMISSION', false)
        }
        const submit = async () => {
            if(!users.value) {
                Message.error('请添加用户')
                return
            }
            if(isEmpty(checkList.value)) {
                Message.error('请选择权限')
                return
            }
            if(!checkList.value.includes(FilePower['PREVIEW'])) checkList.value.push(FilePower['PREVIEW'])
            const userIds = (users.value && users.value.split(',')) || []
            const res = await grantPower({ dirId, powers: checkList.value, userIds })
            if (res.code === 0) {
                closeOut()
            }
        }
        const validateIpt = () => {
            //  匹配中文
            users.value = users.value && users.value.replace(/[\u4e00-\u9fa5]/g, '')
        }
        return {
            outVisible,
            dirId,
            checkList,
            closeOut,
            submit,
            users,
            validateIpt,
        }
    },
})
